import Post from "@components/Story/Post";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/StoryArticleService/getter";
import { formatDateDisplay } from "@utils/dateFormatter";
import _ from "lodash";

const View = () => {
  const { articles } = usePageContext();
  const data = _.map(articles, (article) => ({
    topic: getter.category(article).name,
    image: getter.image(article),
    date: formatDateDisplay(getter.publishedAt(article)),
    title: getter.title(article),
    description: getter.description(article),
    slug: getter.slug(article),
  }));
  return (
    <div data-scroll-section>
      <Post data={data} />
    </div>
  );
};
export default View;
